import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const RADIAN = Math.PI / 180;

const renderNeedle = ({
    value,
    data,
    cx,
    cy,
    iR,
    oR,
    color,
}: {
    value: number;
    data: any[];
    cx: number;
    cy: number;
    iR: number;
    oR: number;
    color: string;
}) => {
    const total = data.reduce((acc, d) => acc + d.value, 0);
    const valueOrMax = value > total ? total : value;
    const ang = 180.0 * (1 - valueOrMax / total);
    const length = (iR + 2 * oR) / 3;
    const sin = Math.sin(-RADIAN * ang);
    const cos = Math.cos(-RADIAN * ang);
    const r = 5;
    const x0 = cx + 5;
    const y0 = cy + 5;
    const xba = x0 + r * sin;
    const yba = y0 - r * cos;
    const xbb = x0 - r * sin;
    const ybb = y0 + r * cos;
    const xp = x0 + length * cos;
    const yp = y0 + length * sin;

    return (
        <>
            <circle cx={x0} cy={y0} r={r} fill={color} stroke="none" />
            <path d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`} stroke="#none" fill={color} />
        </>
    );
};

export function MonthlyPlacementChart({ value, goal }: Readonly<{ value: number; goal: number }>) {
    const needleColor = "var(--bs-primary)";
    const centerX = 50;
    const centerY = 30;
    const innerRadius = 20;
    const outerRadius = 35;

    const sections = [
        { name: "1", value: goal, color: "url(#gradientStart)" },
        { name: "2", value: goal, color: "url(#gradientSuccess)" },
    ];

    return (
        <div style={{ height: "40px", width: "100px" }} className="d-flex justify-content-center">
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                    <defs>
                        <linearGradient id="gradientStart" x1="0" y1="1" x2="1" y2="0">
                            <stop offset="0%" stopColor="#c00000" />
                            <stop offset="50%" stopColor="var(--bs-warning)" />
                            <stop offset="100%" stopColor="#30d030" />
                        </linearGradient>
                        <linearGradient id="gradientSuccess" x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0%" stopColor="var(--bs-success)" />
                            <stop offset="100%" stopColor="var(--bs-info)" />
                        </linearGradient>
                    </defs>
                    <Pie
                        dataKey="value"
                        startAngle={180}
                        endAngle={0}
                        data={sections}
                        cx={centerX}
                        cy={centerY}
                        innerRadius={innerRadius}
                        outerRadius={outerRadius}
                        fill="#8884d8"
                        stroke="none"
                    >
                        {sections.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                    {renderNeedle({
                        value,
                        data: sections,
                        cx: centerX,
                        cy: centerY,
                        iR: innerRadius,
                        oR: outerRadius,
                        color: needleColor,
                    })}
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}
